//
// OFI client logic
//

var otherFinancialInstitutions = (function () {
    'use strict';

    // Variables

    // Methods

    $(document).ready(function () {
        $("select[name='product']").change(handleAccountBalanceInput);
    });

    function handleAccountBalanceInput() {
        var value = this.value,
            productWrp = $(this).closest('.ofi-expander-item'),
            limitInput = productWrp.find("input[name='credit_limit']"),
            frequencyInput = productWrp.find("select[name='repayment_frequency']"),
            repaymentInput = productWrp.find("input[name='repayment_amount']"),
            limitInputId = limitInput.attr("id"),
            frequencyInputId = frequencyInput.attr("id"),
            repaymentInputId = repaymentInput.attr("id"),
            limitReduiredIdentifier = $('label[for="' + limitInputId + '"]').find("sup"),
            frequencyReduiredIdentifier = $('label[for="' + frequencyInputId + '"]').find("sup"),
            repaymentReduiredIdentifier = $('label[for="' + repaymentInputId + '"]').find("sup"),
            limitError = "#" + $(limitInput).attr("aria-describedby"),
            frequencyError = "#" + $(frequencyInput).attr("aria-describedby"),
            repaymentError = "#" + $(repaymentInput).attr("aria-describedby"),
            enabledObject = { 'required': 'required', 'aria-required': true, "disabled": false  },
            disabledObject = {"required": false, "aria-required": false, "disabled": true };

        if (value === "Mortgage - Owner Occupier" || value === "Mortgage - Investment" || value === "Personal Loan" || value === "Payday Lenders") {
            $(limitInput).attr(disabledObject);
            $(limitInput).val('');
            limitReduiredIdentifier.hide();
            $(limitError).hide();
        }
        else {
            $(limitInput).attr(enabledObject);
            limitReduiredIdentifier.show();
        }

        if (value === "Personal Overdrafts" || value === "Business Overdrafts" || value === "Line of Credit") {
            $(frequencyInput).find("option:selected").prop("selected", false);
            $(repaymentInput).val('');
            $(frequencyInput).attr(disabledObject);
            $(repaymentInput).attr(disabledObject);
            frequencyReduiredIdentifier.hide();
            repaymentReduiredIdentifier.hide();
            $(frequencyError).hide();
            $(repaymentError).hide();
        }
        else {
            $(frequencyInput).attr(enabledObject);
            $(repaymentInput).attr(enabledObject);
            frequencyReduiredIdentifier.show();
            repaymentReduiredIdentifier.show();
        }
    };

})();